export const AspectRatio = {
    SQUARE_1_TO_1: 'Square - 1:1',
    LANDSCAPE_1PT91_TO_1: 'Landscape - 1.91:1',
    THIRTYFIVE_MILLIMETER_3_TO_2: '35mm - 3:2',
    MEDIUM_FORMAT_5_TO_4: 'Medium Format - 5:4',
    LANDSCAPE_16_TO_9: 'Landscape - 16:9',
    PORTRAIT_9_TO_16: 'Portrait - 9:16',
    PORTRAIT_2_3: 'Portrait - 2:3',
    PORTRAIT_4_5: 'Portrait - 4:5'
};



// WEBPACK FOOTER //
// ./common/language/content_component/aspect_ratio.js